import React, { useState } from "react";
import "../styles/Home.css";
import about from "../assets/about.jpg";
import blog1 from "../assets/blog-1.jpg";
import blog2 from "../assets/blog-2.jpg";
import hero from "../assets/hero.jpg";
import contactBanner from "../assets/banner-contactus.jpg";

const blogs = [
  {
    id: 1,
    image: blog1,
    category: "Pet Care",
    type: "Guide",
    readTime: "4 min read",
    date: "13 Jul, 2026",
    title: "Simple ways to keep pets active indoors",
    description:
      "Enrichment toys, short training games, and routine play help pets stay healthy between walks.",
  },
  {
    id: 2,
    image: blog2,
    category: "Nutrition",
    type: "Checklist",
    readTime: "3 min read",
    date: "13 Jul, 2026",
    title: "Choosing food by age, size, and habit",
    description:
      "Match portions and formulas to your pet's life stage, activity level, and vet guidance.",
  },
  {
    id: 3,
    image: about,
    category: "Grooming",
    type: "Tips",
    readTime: "5 min read",
    date: "12 Jul, 2026",
    title: "A calm grooming routine for nervous pets",
    description:
      "Short sessions, familiar tools, and reward breaks can make brushing and nail care easier.",
  },
  {
    id: 4,
    image: hero,
    category: "Shopping",
    type: "Buying Guide",
    readTime: "6 min read",
    date: "11 Jul, 2026",
    title: "What to stock before bringing home a new pet",
    description:
      "Start with food, bowls, ID tags, bedding, waste supplies, and a few safe enrichment toys.",
  },
  {
    id: 5,
    image: contactBanner,
    category: "Wellness",
    type: "Safety",
    readTime: "4 min read",
    date: "10 Jul, 2026",
    title: "Small signs your pet may need a routine checkup",
    description:
      "Changes in appetite, sleep, coat, or energy are worth tracking and sharing with your vet.",
  },
  {
    id: 6,
    image: blog1,
    category: "Training",
    type: "Routine",
    readTime: "3 min read",
    date: "09 Jul, 2026",
    title: "Five-minute training games that fit busy days",
    description:
      "Simple cues, scent games, and recall practice can build confidence without long sessions.",
  },
];

const HomePage = () => {
  const [activeTab, setActiveTab] = useState("mission");
  return (
    <div className="homepage">
      <section className="hero">
        <div className="hero-content">
          <h1>Pet Shop</h1>
          <p>MAKE YOUR PETS HAPPY</p>
          <p>
            Food, toys, grooming, and everyday care essentials for healthier,
            happier pets.
          </p>
          <a className="read-more" href="/shop">Shop Now</a>
          <a className="play-video" href="/about">About Us</a>
        </div>
      </section>

      <div className="about-section">
        <div className="about-container">
          <div className="about-row">
            {/* Image Section */}
            <div className="about-image-container">
              <img src={about} alt="About Us" className="about-image" />
            </div>

            {/* Text Section */}
            <div className="about-content">
              <div className="about-header">
                <h6 className="text-primary">About Us</h6>
                <h2>We Keep Your Pets Happy All Time</h2>
              </div>
              <h4 className="about-description">
                We pair dependable products with practical pet care guidance so
                owners can shop with confidence.
              </h4>

              {/* Tabs Section */}
              <div className="about-tabs">
                <div className="tab-buttons">
                  <button
                    className={`tab-btn ${
                      activeTab === "mission" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("mission")}
                  >
                    Our Mission
                  </button>
                  <button
                    className={`tab-btn ${
                      activeTab === "vision" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("vision")}
                  >
                    Our Vision
                  </button>
                </div>

                <div className="tab-content">
                  {activeTab === "mission" && (
                    <div className="tab-panel active">
                      <p>
                        Make everyday pet care easier with trusted products,
                        friendly service, and clear advice.
                      </p>
                      <ul>
                        <li>Recommend products that match real pet routines.</li>
                        <li>Keep essentials easy to find and understand.</li>
                      </ul>
                    </div>
                  )}
                  {activeTab === "vision" && (
                    <div className="tab-panel active">
                      <p>
                        Build a local pet store experience that feels useful,
                        warm, and simple from browsing to checkout.
                      </p>
                      <ul>
                        <li>Grow a trusted care hub for pet owners.</li>
                        <li>Make every visit feel practical and welcoming.</li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="services">
        <h2>Our Excellent Pet Care Services</h2>
        <div className="services-grid">
          <div className="service-item">
            <span className="service-number">01</span>
            <h4>Pet Boarding</h4>
            <p>Comfortable short-term care with clean routines.</p>
          </div>
          <div className="service-item">
            <span className="service-number">02</span>
            <h4>Pet Feeding</h4>
            <p>Food recommendations by age, size, and habit.</p>
          </div>
          <div className="service-item">
            <span className="service-number">03</span>
            <h4>Pet Grooming</h4>
            <p>Bathing, brushing, trims, and coat care basics.</p>
          </div>
          <div className="service-item">
            <span className="service-number">04</span>
            <h4>Pet Training</h4>
            <p>Positive routines for calmer daily behavior.</p>
          </div>
          <div className="service-item">
            <span className="service-number">05</span>
            <h4>Pet Exercise</h4>
            <p>Toys and play plans for active bodies and minds.</p>
          </div>
          <div className="service-item">
            <span className="service-number">06</span>
            <h4>Pet Treatment</h4>
            <p>Care essentials that support vet-led wellness.</p>
          </div>
        </div>
      </section>
      <div className="blog-section">
        <div className="container">
          {/* Section Header */}
          <div className="section-header">
            <div>
              <h6 className="section-subtitle">Latest Blog</h6>
              <h1 className="section-title">Care notes for better pet days</h1>
            </div>
            <p>
              Practical reads for feeding, grooming, shopping, and keeping pets
              comfortable at home.
            </p>
          </div>

          {/* Blog Grid */}
          <div className="blog-grid">
            {blogs.map((blog) => (
              <div key={blog.id} className="blog-card">
                {/* Blog Image */}
                <div className="blog-image">
                  <img src={blog.image} alt={blog.title} />
                </div>
                {/* Blog Content */}
                <div className="blog-content">
                  <div className="blog-meta">
                    <span className="blog-type">{blog.type}</span>
                    <span>
                      <i className="icon-bookmark"></i> {blog.category}
                    </span>
                    <span>
                      <i className="icon-calendar"></i> {blog.date}
                    </span>
                    <span>{blog.readTime}</span>
                  </div>
                  <h5 className="blog-title">{blog.title}</h5>
                  <p className="blog-description">{blog.description}</p>
                  <span className="blog-read-more">
                    Read More <i className="icon-chevron-right"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
